export function _buildQuery(params) {
  let string = "";

  for (let key in params) {
    if (params[key] !== "") {
      string += `${key}=${params[key]}&`;
    }
  }
  string = "?" + string.substring(0, string.length - 1);
  return string;
}

export function _setupTreeView(type_agencies, is_aa = true) {
  let treeData = [];
  type_agencies.forEach((element) => {
    const node = {
      id: element.slug,
      label: element.name,
      children: [],
    };
    element.agencies.forEach((agence) => {
      if (element.id === agence.type_agence_id) {
        agence.teams.forEach((team) => {
          if (is_aa) {
            node.children.push({
              id: team.id,
              label: team.name,
            });
          } else {
            if (team.is_aa == "0") {
              node.children.push({
                id: team.id,
                label: team.name,
              });
            }
          }
        });
      }
    });
    treeData.push(node);
  });
  return treeData;
}

export function __cryptNumber(number, crypt_by = "X") {
  let crypted_number = "";
  let start = number.substring(0, 2);
  let end = number.substring(6);

  crypted_number += "+229 " + start + " XX XX " + end;

  return crypted_number;
}
